import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "documente-wrapper" }
const _hoisted_2 = { class: "circle-container" }
const _hoisted_3 = {
  key: 0,
  class: "circle circle-true"
}
const _hoisted_4 = {
  key: 1,
  class: "circle circle-false"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "url-textbox" }
const _hoisted_7 = { class: "show-more-container" }
const _hoisted_8 = { class: "form-footer footer-modern" }
const _hoisted_9 = { class: "footer-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxExport = _resolveComponent("DxExport")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxTexts = _resolveComponent("DxTexts")!
  const _component_DxGrouping = _resolveComponent("DxGrouping")!
  const _component_DxGroupPanel = _resolveComponent("DxGroupPanel")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxStateStoring = _resolveComponent("DxStateStoring")!
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxTextBoxButton = _resolveComponent("DxTextBoxButton")!
  const _component_DxTextBox = _resolveComponent("DxTextBox")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxTreeView = _resolveComponent("DxTreeView")!
  const _component_DxDropDownBox = _resolveComponent("DxDropDownBox")!
  const _component_DxSimpleItem = _resolveComponent("DxSimpleItem")!
  const _component_DxDropDownOptions = _resolveComponent("DxDropDownOptions")!
  const _component_DxLookup = _resolveComponent("DxLookup")!
  const _component_DxDateBox = _resolveComponent("DxDateBox")!
  const _component_DxGroupItem = _resolveComponent("DxGroupItem")!
  const _component_DxNumberBox = _resolveComponent("DxNumberBox")!
  const _component_DxFormItem = _resolveComponent("DxFormItem")!
  const _component_DxTextArea = _resolveComponent("DxTextArea")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_DxDataGrid, {
        ref: $data.documenteDataGrid,
        allowColumnReordering: true,
        "data-source": $data.dsDocumente,
        allowColumnResizing: true,
        columnAutoWidth: false,
        "column-min-width": 10,
        columnResizingMode: 'nextColumn',
        "show-borders": true,
        syncLookupFilterValues: false,
        "filter-sync-enabled": true,
        "show-column-lines": false,
        "show-row-lines": true,
        "row-alternation-enabled": true,
        "hover-state-enabled": true,
        height: "100%",
        class: "documente-grid",
        onRowDblClick: $options.onRowDblClick
      }, {
        circleTemplate: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_2, [
            (data.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, "✔"))
              : (_openBlock(), _createElementBlock("div", _hoisted_4))
          ])
        ]),
        numarLinkTemplate: _withCtx(({ data }) => [
          _createElementVNode("a", {
            class: "numar-link",
            onClick: _withModifiers(($event: any) => ($options.openDocument(data.data)), ["prevent"])
          }, _toDisplayString(data.value), 9, _hoisted_5)
        ]),
        filterToggleTemplate: _withCtx(() => [
          _createVNode(_component_DxButton, {
            icon: "filter",
            text: "Filtre",
            "styling-mode": "contained",
            class: "filter-toggle-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-filters')))
          })
        ]),
        periodToggleTemplate: _withCtx(() => [
          _createVNode(_component_DxButton, {
            icon: "event",
            text: "Perioadă",
            "styling-mode": "contained",
            class: "filter-toggle-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-filters', 'date')))
          })
        ]),
        documentToggleTemplate: _withCtx(() => [
          _createVNode(_component_DxButton, {
            icon: "doc",
            text: "Document",
            "styling-mode": "contained",
            class: "filter-toggle-btn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggle-filters', 'document')))
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_DxExport, {
            enabled: true,
            formats: ["pdf", "xlsx"],
            "load-panel": { enabled: true, showIndicator: true, text: 'Loading...' }
          }),
          _createVNode(_component_DxFilterRow, { visible: true }),
          _createVNode(_component_DxGrouping, { "context-menu-enabled": true }, {
            default: _withCtx(() => [
              _createVNode(_component_DxTexts, {
                "group-continued-message": "Continuat de pe pagina anterioara",
                "group-continues-message": "Continuat pe pagina urmatoare"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_DxGroupPanel, {
            visible: true,
            emptyPanelText: "Trage aici o coloana pentru a grupa datele"
          }),
          _createVNode(_component_DxLoadPanel, {
            enabled: true,
            text: "Loading...",
            "indicator-src": 'reload6.gif'
          }),
          _createVNode(_component_DxSorting, { mode: "multiple" }),
          _createVNode(_component_DxStateStoring, {
            enabled: true,
            filterValue: false,
            "storage-key": "dsDocumente"
          }),
          _createVNode(_component_DxColumnChooser, {
            enabled: true,
            title: "Selector coloane",
            allowSearch: true,
            sortOrder: "asc"
          }),
          _createVNode(_component_DxSearchPanel, {
            visible: true,
            width: 240,
            placeholder: "Cauta ..."
          }),
          _createVNode(_component_DxPaging, {
            "page-size": 10,
            "page-index": 0
          }),
          _createVNode(_component_DxToolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_DxItem, {
                location: "before",
                template: "filterToggleTemplate"
              }),
              _createVNode(_component_DxItem, {
                location: "before",
                template: "periodToggleTemplate"
              }),
              _createVNode(_component_DxItem, {
                location: "before",
                template: "documentToggleTemplate"
              }),
              _createVNode(_component_DxItem, {
                widget: "dxButton",
                location: "after",
                options: $data.addButtonOptions
              }, null, 8, ["options"]),
              _createVNode(_component_DxItem, { name: "searchPanel" }),
              _createVNode(_component_DxItem, { name: "exportButton" }),
              _createVNode(_component_DxItem, { name: "columnChooserButton" })
            ]),
            _: 1
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Numar",
            "cell-template": "numarLinkTemplate"
          }),
          _createVNode(_component_DxColumn, { "data-field": "Categorie" }),
          _createVNode(_component_DxColumn, { "data-field": "Tip" }),
          _createVNode(_component_DxColumn, {
            "data-field": "Data",
            caption: "Data Contabila",
            "data-type": "date",
            format: "yyyy-MM-dd"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Document",
            caption: "Document asociat",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Zona",
            caption: "Zona",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "AgentNume",
            caption: "Nume Agent",
            allowHiding: false,
            showInColumnChooser: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Curs",
            caption: "Custom Curs Valutar",
            visible: false,
            "data-type": "number",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "LotFabricatie",
            caption: "Lot Fabricatie",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "TvaLaIncasare",
            caption: "TVA La Incasare?",
            visible: false,
            cellTemplate: "circleTemplate",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Explicatie",
            caption: "Explicatie",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "DiverseExplicatii",
            caption: "Diverse Explicatii",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Observatii",
            caption: "Observatii",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "ContractNumar",
            caption: "Numar Contract",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "LocDepozitare",
            caption: "Loc de Depozitare",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Autofacturat",
            caption: "Autofacturat?",
            visible: false,
            cellTemplate: "circleTemplate",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Nota",
            caption: "Nota Contabila",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, { caption: "Date Parteneri" }, {
            default: _withCtx(() => [
              _createVNode(_component_DxColumn, {
                "data-field": "GrupPartener",
                caption: "Grup Partener",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Partener",
                caption: "Nume Partener",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "PartenerStrada",
                caption: "Strada Partener",
                visible: false,
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "PartenerStradaNumar",
                caption: "Numar Strada Partener",
                visible: false,
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "PartenerScaraBloc",
                caption: "Scara Bloc Partener",
                visible: false,
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "PartenerBloc",
                caption: "Bloc Partener",
                visible: false,
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "PartenerLocalitate",
                caption: "Localitate Partener",
                visible: false,
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "PartenerAtributFiscal",
                caption: "Atribut Fiscal Partener",
                visible: false,
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "PartenerCod",
                caption: "Cod Partener",
                visible: false,
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "PartenerCUI",
                caption: "CUI Partener",
                visible: false,
                allowSearch: false
              })
            ]),
            _: 1
          }),
          _createVNode(_component_DxColumn, { caption: "Termene" }, {
            default: _withCtx(() => [
              _createVNode(_component_DxColumn, {
                "data-field": "DataDoc",
                caption: "Data Document",
                visible: false,
                "data-type": "date",
                format: "yyyy-MM-dd"
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Scadenta",
                caption: "Data Scadenta",
                visible: false,
                "data-type": "date",
                format: "yyyy-MM-dd"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_DxColumn, { caption: "CAF" }, {
            default: _withCtx(() => [
              _createVNode(_component_DxColumn, {
                "data-field": "AreCAF",
                caption: "Are CAF?",
                visible: false,
                "cell-template": "circleTemplate",
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "ProcentCAF",
                caption: "Procent CAF",
                visible: false,
                "data-type": "number",
                format: "#0.00",
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "ValoareCAF",
                caption: "Valoare CAF",
                visible: false,
                "data-type": "number",
                allowSearch: false
              })
            ]),
            _: 1
          }),
          _createVNode(_component_DxColumn, { caption: "Gestionare" }, {
            default: _withCtx(() => [
              _createVNode(_component_DxColumn, {
                "data-field": "GestiuneIntrare",
                caption: "Gestiune Intrare",
                visible: false,
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "GestiuneIesire",
                caption: "Gestiune Iesire",
                visible: false,
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "GestionarIntrare",
                caption: "Gestionar Intrare",
                visible: false,
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "GestionarIesire",
                caption: "Gestionar Iesire",
                visible: false,
                allowSearch: false
              })
            ]),
            _: 1
          }),
          _createVNode(_component_DxColumn, { caption: "Audit" }, {
            default: _withCtx(() => [
              _createVNode(_component_DxColumn, {
                "data-field": "DataCreare",
                caption: "Data Creare",
                visible: false,
                "data-type": "date",
                format: "yyyy-MM-dd"
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "DataModificare",
                caption: "Data Modificare",
                visible: false,
                "data-type": "date",
                format: "yyyy-MM-dd"
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "UserCreare",
                caption: "User Creare",
                visible: false,
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "UserModificare",
                caption: "User Modificare",
                visible: false,
                allowSearch: false
              })
            ]),
            _: 1
          }),
          _createVNode(_component_DxColumn, { caption: "Rezumat Financiar RON" }, {
            default: _withCtx(() => [
              _createVNode(_component_DxColumn, {
                "data-field": "ValoareRON",
                caption: "Valoare in RON",
                visible: false,
                "data-type": "number",
                alignment: "right",
                format: "#0.00",
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "ValoareTVARON",
                caption: "Valoare TVA in RON",
                visible: false,
                "data-type": "number",
                format: "#0.00",
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "TotalRON",
                caption: "Total in RON",
                visible: false,
                "data-type": "number",
                format: "#0.00",
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "SoldRON",
                caption: "Sold RON",
                visible: false,
                "data-type": "number",
                allowSearch: false
              })
            ]),
            _: 1
          }),
          _createVNode(_component_DxColumn, { caption: "Rezumat Financiar" }, {
            default: _withCtx(() => [
              _createVNode(_component_DxColumn, {
                "data-field": "Valoare",
                caption: "Valoare",
                visible: false,
                "data-type": "number",
                alignment: "right",
                format: "#0.00",
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Valuta",
                visible: false,
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "TVA",
                caption: "TVA",
                visible: false,
                "data-type": "number",
                alignment: "right",
                format: "#0'%'",
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "ValoareTVA",
                caption: "Valoare TVA",
                visible: false,
                "data-type": "number",
                format: "#0.00",
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Total",
                caption: "Total",
                visible: false,
                "data-type": "number",
                format: "#0.00",
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Adaos",
                caption: "Adaos",
                visible: false,
                "data-type": "number",
                format: "#0.00",
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "AdaosValoare",
                caption: "Valoare Adaos",
                visible: false,
                "data-type": "number",
                format: "#0.00",
                allowSearch: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Sold",
                caption: "Sold",
                visible: false,
                "data-type": "number",
                allowSearch: false
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data-source", "onRowDblClick"])
    ]),
    _createVNode(_component_DxPopup, {
      visible: $data.sharePopupVisible,
      width: "430",
      height: "170",
      showTitle: true,
      hideOnOutsideClick: $options.switchSharePopup,
      "drag-enabled": true,
      position: "center"
    }, {
      title: _withCtx(() => [...(_cache[7] || (_cache[7] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Copiază Link Detalii Document ", -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_DxTextBox, {
            value: $data.url,
            readOnly: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxTextBoxButton, {
                options: $data.copyButton,
                name: "copy",
                readOnly: false
              }, null, 8, ["options"])
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "hideOnOutsideClick"]),
    _createVNode(_component_DxPopupAdd, {
      visible: $data.isModalAddVisible,
      "show-title": true,
      height: "70vh",
      width: "82vw",
      "drag-enabled": true,
      "show-close-button": false
    }, {
      title: _withCtx(() => [...(_cache[8] || (_cache[8] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare document"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează detaliile documentului în pașii de mai jos ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nou ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_DxForm, {
          "col-count": 4,
          "data-source": $data.newDocument,
          class: "modern-form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxGroupItem, {
              caption: "Informații Document",
              "col-span": 2,
              "col-count": 2,
              "css-class": "form-section-simple form-section-card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxSimpleItem, {
                  "col-span": 1,
                  "data-field": "TipId",
                  "is-required": true,
                  label: { text: 'Tip Document' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxDropDownBox, {
                      ref: "dropDownBoxRef",
                      "data-source": $data.dsTipDocumente,
                      value: $data.newDocument.TipId,
                      "value-expr": "Id",
                      "display-expr": "Nume",
                      placeholder: "Selectează un tip de document...",
                      showClearButton: true,
                      onValueChanged: $options.onDropDownValueChanged
                    }, {
                      content: _withCtx(({ data }) => [
                        ($data.treeViewDataSource)
                          ? (_openBlock(), _createBlock(_component_DxTreeView, {
                              key: 0,
                              "data-source": $data.treeViewDataSource,
                              "select-by-click": true,
                              "data-structure": "tree",
                              "items-expr": "items",
                              "key-expr": "Id",
                              "search-enabled": true,
                              "search-mode": "contains",
                              "select-nodes-recursive": false,
                              "expand-nodes-on-search": true,
                              onItemClick: $options.onTreeViewItemSelectionChanged,
                              "focus-state-enabled": true,
                              "display-expr": "Nume"
                            }, {
                              item: _withCtx(({ data: itemData }) => [
                                _createElementVNode("span", {
                                  style: _normalizeStyle({ fontWeight: itemData.isCategory ? 'bold' : 'normal' })
                                }, _toDisplayString(itemData.Nume), 5)
                              ]),
                              _: 1
                            }, 8, ["data-source", "onItemClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["data-source", "value", "onValueChanged"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxSimpleItem, {
                  "col-span": 1,
                  "data-field": "Numar",
                  label: { text: 'Număr Document' },
                  placeholder: "#AUTO"
                }),
                _createVNode(_component_DxSimpleItem, {
                  "col-span": 2,
                  "data-field": "PartenerId",
                  label: { text: 'Partener' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxLookup, {
                      "data-source": $data.dsPartener,
                      value: $data.newDocument.PartenerId,
                      "value-expr": "ID",
                      "display-expr": "Nume",
                      placeholder: "Selectează un partener...",
                      showClearButton: true,
                      searchEnabled: true,
                      onValueChanged: $options.onPartenerSelected
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownOptions, { "show-title": false })
                      ]),
                      _: 1
                    }, 8, ["data-source", "value", "onValueChanged"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxSimpleItem, {
                  "col-span": 1,
                  "data-field": "Data",
                  label: { text: 'Data Contabilă' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxDateBox, {
                      value: $data.newDocument.Data,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (($data.newDocument.Data) = $event)),
                      type: "date",
                      "display-format": "dd-MM-yyyy",
                      "show-clear-button": true,
                      placeholder: "Data...",
                      "label-mode": "hidden"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxSimpleItem, {
                  "col-span": 1,
                  "data-field": "DataDoc",
                  label: { text: 'Data Document' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxDateBox, {
                      value: $data.newDocument.DataDoc,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (($data.newDocument.DataDoc) = $event)),
                      type: "date",
                      "display-format": "dd-MM-yyyy",
                      "show-clear-button": true,
                      placeholder: "Data document...",
                      "label-mode": "hidden"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_DxGroupItem, {
              caption: "Financiar & Logistică",
              "col-span": 2,
              "col-count": 2,
              "css-class": "form-section-simple form-section-card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxSimpleItem, {
                  "col-span": 1,
                  "data-field": "GestiuneIntrareId",
                  label: { text: 'Gestiune Intrare' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxLookup, {
                      "data-source": $data.dsGestiune,
                      value: $data.newDocument.GestiuneIntrareId,
                      "value-expr": "Id",
                      "display-expr": "Nume",
                      placeholder: "Gestiune intrare...",
                      showClearButton: true,
                      searchEnabled: true,
                      onValueChanged: $options.onGestiuneIntrareSelected
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownOptions, { "show-title": false })
                      ]),
                      _: 1
                    }, 8, ["data-source", "value", "onValueChanged"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxSimpleItem, {
                  "col-span": 1,
                  "data-field": "GestiuneIesireId",
                  label: { text: 'Gestiune Ieșire' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxLookup, {
                      "data-source": $data.dsGestiune,
                      value: $data.newDocument.GestiuneIesireId,
                      "value-expr": "Id",
                      "display-expr": "Nume",
                      placeholder: "Gestiune ieșire...",
                      showClearButton: true,
                      searchEnabled: true,
                      onValueChanged: $options.onGestiuneIesireSelected
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownOptions, { "show-title": false })
                      ]),
                      _: 1
                    }, 8, ["data-source", "value", "onValueChanged"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxSimpleItem, {
                  "col-span": 1,
                  "data-field": "ValutaId",
                  label: { text: 'Valută' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxLookup, {
                      "data-source": $data.dsValute,
                      value: $data.newDocument.ValutaId,
                      "value-expr": "Id",
                      "display-expr": "Simbol",
                      placeholder: "Valută...",
                      showClearButton: true,
                      searchEnabled: true,
                      onValueChanged: $options.onValutaSelected
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownOptions, { "show-title": false })
                      ]),
                      _: 1
                    }, 8, ["data-source", "value", "onValueChanged"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxSimpleItem, {
                  "col-span": 1,
                  "data-field": "Curs",
                  label: { text: 'Curs' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxNumberBox, {
                      value: $data.newDocument.Curs,
                      readOnly: true,
                      onValueChanged: $options.onCursSelected
                    }, null, 8, ["value", "onValueChanged"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxSimpleItem, {
                  "col-span": 1,
                  "data-field": "PretValutaId",
                  label: { text: 'Preț Valută' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxLookup, {
                      "data-source": $data.dsValute,
                      value: $data.newDocument.PretValutaId,
                      "value-expr": "Id",
                      "display-expr": "Simbol",
                      placeholder: "Valută preț...",
                      showClearButton: true,
                      searchEnabled: true,
                      onValueChanged: $options.onPretValutaSelected
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownOptions, { "show-title": false })
                      ]),
                      _: 1
                    }, 8, ["data-source", "value", "onValueChanged"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxSimpleItem, {
                  "col-span": 1,
                  "data-field": "PretCurs",
                  label: { text: 'Preț Curs' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxNumberBox, {
                      value: $data.newDocument.PretCurs,
                      readOnly: true,
                      onValueChanged: $options.onPretCursSelected
                    }, null, 8, ["value", "onValueChanged"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_DxFormItem, {
              "col-span": 4,
              "col-count": 4
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "show-more-native-btn",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($data.showExtendedDetails = !$data.showExtendedDetails))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass($data.showExtendedDetails ? 'dx-icon dx-icon-chevronup' : 'dx-icon dx-icon-chevrondown')
                    }, null, 2),
                    _createElementVNode("span", null, _toDisplayString($data.showExtendedDetails ? 'Ascunde detalii suplimentare' : 'Completează detalii suplimentare'), 1)
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGroupItem, {
              caption: "Referințe",
              "col-span": 2,
              "col-count": 2,
              visible: $data.showExtendedDetails,
              "css-class": "form-section-simple form-section-card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxSimpleItem, {
                  "col-span": 2,
                  "data-field": "ProiectId",
                  label: { text: 'Proiect' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxLookup, {
                      "data-source": $data.dsProiecte,
                      value: $data.newDocument.ProiectId,
                      "value-expr": "Id",
                      "display-expr": "Nume",
                      placeholder: "Selectează un proiect...",
                      showClearButton: true,
                      searchEnabled: true,
                      onValueChanged: $options.onProiectSelected
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownOptions, { "show-title": false })
                      ]),
                      _: 1
                    }, 8, ["data-source", "value", "onValueChanged"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxSimpleItem, {
                  "col-span": 1,
                  "data-field": "ContractId",
                  label: { text: 'Contract' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxLookup, {
                      "data-source": $data.dsContracte,
                      value: $data.newDocument.ContractId,
                      "value-expr": "Id",
                      "display-expr": "NumeContract",
                      placeholder: "Selectează un contract...",
                      showClearButton: true,
                      searchEnabled: true,
                      onValueChanged: $options.onContractSelected
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownOptions, { "show-title": false })
                      ]),
                      _: 1
                    }, 8, ["data-source", "value", "onValueChanged"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxSimpleItem, {
                  "col-span": 1,
                  "data-field": "ComandaId",
                  label: { text: 'Comandă' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxLookup, {
                      "data-source": $data.dsComenzi,
                      value: $data.newDocument.ComandaId,
                      "value-expr": "Id",
                      "display-expr": "Cod",
                      placeholder: "Selectează o comandă...",
                      showClearButton: true,
                      searchEnabled: true,
                      onValueChanged: $options.onComandaSelected
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownOptions, { "show-title": false })
                      ]),
                      _: 1
                    }, 8, ["data-source", "value", "onValueChanged"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxSimpleItem, {
                  "col-span": 1,
                  "data-field": "StructIdEditabil",
                  label: { text: 'Structură Editabilă' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxLookup, {
                      "data-source": $data.dsStructuriIdEditabile,
                      value: $data.newDocument.StructIdEditabil,
                      "value-expr": "Id",
                      "display-expr": "Nume",
                      placeholder: "Selectează o structură...",
                      showClearButton: true,
                      searchEnabled: true,
                      onValueChanged: $options.onStructuraIdEditabilaSelected
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownOptions, { "show-title": false })
                      ]),
                      _: 1
                    }, 8, ["data-source", "value", "onValueChanged"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxSimpleItem, {
                  "col-span": 1,
                  "data-field": "DataScadenta",
                  label: { text: 'Data Scadență' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxDateBox, {
                      value: $data.newDocument.DataScadenta,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (($data.newDocument.DataScadenta) = $event)),
                      type: "date",
                      "display-format": "dd-MM-yyyy",
                      "show-clear-button": true,
                      placeholder: "Selectează data scadenței...",
                      "label-mode": "hidden"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["visible"]),
            _createVNode(_component_DxGroupItem, {
              caption: "Note & Observații",
              "col-span": 2,
              "col-count": 1,
              visible: $data.showExtendedDetails,
              "css-class": "form-section-simple form-section-card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxSimpleItem, {
                  "data-field": "Explicatie",
                  label: { text: 'Explicație' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxTextArea, {
                      value: $data.newDocument.Explicatie,
                      height: "52px",
                      onValueChanged: $options.onExplicatieSelected
                    }, null, 8, ["value", "onValueChanged"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxSimpleItem, {
                  "data-field": "Observatii",
                  label: { text: 'Observații' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxTextArea, {
                      value: $data.newDocument.Observatii,
                      height: "52px",
                      onValueChanged: $options.onObservatiiSelected
                    }, null, 8, ["value", "onValueChanged"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["visible"])
          ]),
          _: 1
        }, 8, ["data-source"]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_DxButton, {
              text: "Salvează",
              type: "success",
              width: "120",
              height: "32",
              "styling-mode": "outlined",
              onClick: $options.onSaveAdd
            }, null, 8, ["onClick"]),
            _createVNode(_component_DxButton, {
              text: "Închide",
              type: "danger",
              width: "120",
              height: "32",
              "styling-mode": "outlined",
              onClick: $options.onCloseAdd
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}